import { render, staticRenderFns } from "./Zlxg.vue?vue&type=template&id=1b8a6905&scoped=true"
import script from "./Zlxg.vue?vue&type=script&lang=js"
export * from "./Zlxg.vue?vue&type=script&lang=js"
import style0 from "./Zlxg.vue?vue&type=style&index=0&id=1b8a6905&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8a6905",
  null
  
)

export default component.exports